import { render } from "./algorithms-monitor.vue?vue&type=template&id=6077a46a"
import script from "./algorithms-monitor.vue?vue&type=script&lang=js"
export * from "./algorithms-monitor.vue?vue&type=script&lang=js"

import "./algorithms-monitor.vue?vue&type=style&index=0&id=6077a46a&lang=scss"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__